<template>
  <div class="font-bebas text-2xl text-arter-secundaria">
    <slot></slot>
  </div>
</template>
